import React from 'react';
import SummatedComponent from '@crimp/lib-score-systems/dist/components/SummatedComponent';
var selfStyles = require('./styles.scss');
var ListTeamsItemSummated = function (props) {
    if (!props.teamScore.summated) {
        return null;
    }
    var summated = props.teamScore.summated;
    return (React.createElement("div", { className: selfStyles.teamSummated },
        React.createElement(SummatedComponent, { isHeader: true, scoreSystemKey: props.scoreSystemKey, summated: summated })));
};
export default ListTeamsItemSummated;



//////////////////
// WEBPACK FOOTER
// ./src/imports/components/Scoreboard/components/ListTeamsItemSummated.tsx
// module id = 995
// module chunks = 0